export const FtColors = {
    primary: "#546e7a",
}